import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=d76d60b0&scoped=true&"
import script from "./Region.vue?vue&type=script&lang=js&"
export * from "./Region.vue?vue&type=script&lang=js&"
import style0 from "./Region.vue?vue&type=style&index=0&id=d76d60b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76d60b0",
  null
  
)

export default component.exports